import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiPersonaAvatarGroupModule } from '../lib/shared-ui-persona-avatar-group.module'
import { PersonaAvatarGroupDocsComponent } from './persona-avatar-group-docs/persona-avatar-group-docs.component'
import { PersonaAvatarGroupExampleComponent } from './persona-avatar-group-docs/persona-avatar-group-example.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiPersonaAvatarGroupModule
  ],
  declarations: [
    PersonaAvatarGroupDocsComponent,
    PersonaAvatarGroupExampleComponent
  ],
  exports: [
    PersonaAvatarGroupDocsComponent
  ]
})
export class SharedUiPersonaAvatarGroupDocsModule {}
